// extracted by mini-css-extract-plugin
module.exports = {"sim-logo-container":"simLogo_sim-logo-container__2voIT","sim-logo":"simLogo_sim-logo__1pvgq","sim-name":"simLogo_sim-name__3YgEk","sim-image":"simLogo_sim-image__3PRNE"};